module.exports = "<h2 class=\"sr-only\" ng-if=\"!isOpen\">{{::headerText}}</h2>\r\n<a href=\"javascript:;\" class=\"openClosePanel onesite-base\" ng-click=\"togglePanel()\">\r\n    <i class=\"icon-panetoggle_left openClosePanel-openIcon\"></i>\r\n    <span class=\"sr-only\">{{srText}}</span>\r\n</a>\r\n<div ng-transclude class=\"panel-transclude\"></div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/openclosepanels/openclosepanel-template.html
 ** module id = 972
 ** module chunks = 1
 **/